(function () {
  'use strict';

  var tabletMin = 750;
  var tabletMax = 1366;
  var minHeight = 600;

  function isTablet() {
    return window.innerWidth >= tabletMin &&
      window.innerWidth <= tabletMax &&
      window.innerHeight >= minHeight &&
      navigator.maxTouchPoints > 0;
  }

  function syncTabletClass() {
    document.documentElement.classList.toggle('kfa-tablet', isTablet());
  }

  syncTabletClass();
  window.addEventListener('resize', syncTabletClass, { passive: true });
  window.addEventListener('orientationchange', function () {
    window.setTimeout(syncTabletClass, 80);
  }, { passive: true });

  function clearBackForwardTransitionState() {
    if (!isTablet()) return;
    var navigation = performance && performance.getEntriesByType
      ? performance.getEntriesByType('navigation')[0]
      : null;
    if (!navigation || navigation.type !== 'back_forward') return;

    var root = document.documentElement;
    root.classList.remove(
      'kfa-route-leaving',
      'kfa-route-entering',
      'kfa-route-enter-ready',
      'kfa-product-entry-pending'
    );
    try { sessionStorage.removeItem('kfa-route-transition'); } catch (error) {}

    var main = document.getElementById('MainContent');
    if (main) {
      main.style.removeProperty('opacity');
      main.style.removeProperty('visibility');
      main.style.removeProperty('pointer-events');
      main.style.removeProperty('transform');
      main.style.removeProperty('filter');
    }
  }

  window.addEventListener('pageshow', function (event) {
    if (!isTablet()) return;
    if (event.persisted) {
      document.documentElement.classList.remove(
        'kfa-route-leaving',
        'kfa-route-entering',
        'kfa-route-enter-ready',
        'kfa-product-entry-pending'
      );
      try { sessionStorage.removeItem('kfa-route-transition'); } catch (error) {}
    }
    clearBackForwardTransitionState();
  });

  function scrollToWorks(link) {
    if (!isTablet()) return false;
    var href = link.getAttribute('href') || '';
    var hashIndex = href.indexOf('#');
    if (hashIndex === -1) return false;
    var hash = href.slice(hashIndex);
    if (!hash || hash === '#') return false;

    var id;
    try { id = decodeURIComponent(hash.slice(1)); }
    catch (error) { id = hash.slice(1); }

    var target = document.getElementById(id);
    if (!target) return false;

    var getTop = function () {
      var scrollMargin = parseFloat(window.getComputedStyle(target).scrollMarginTop) || 0;
      return Math.max(0, window.scrollY + target.getBoundingClientRect().top - scrollMargin);
    };

    window.scrollTo({ top: getTop(), behavior: 'smooth' });
    window.setTimeout(function () {
      var correctedTop = getTop();
      if (Math.abs(window.scrollY - correctedTop) > 3) {
        window.scrollTo({ top: correctedTop, behavior: 'auto' });
      }
    }, 680);

    if (window.history && window.history.replaceState) {
      window.history.replaceState(window.history.state, '', hash);
    }
    return true;
  }

  document.addEventListener('click', function (event) {
    if (!isTablet()) return;
    var link = event.target.closest(
      '[data-kfa-works-link], .kfa-exhibition-story__works-link[href*="#"]'
    );
    if (!link) return;
    if (scrollToWorks(link)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  function markPriceChange() {
    if (!isTablet()) return;
    var wrapper = document.querySelector('.product-information__header .product-price__wrapper');
    if (!wrapper) return;
    wrapper.classList.remove('kfa-ipad-price-updated');
    void wrapper.offsetWidth;
    wrapper.classList.add('kfa-ipad-price-updated');
    window.setTimeout(function () {
      wrapper.classList.remove('kfa-ipad-price-updated');
    }, 650);
  }

  document.addEventListener('change', function (event) {
    if (!isTablet() || !event.target.closest('variant-picker')) return;
    window.setTimeout(markPriceChange, 80);
  }, true);

  function sameOriginReferrer() {
    if (!document.referrer) return null;
    try {
      var ref = new URL(document.referrer);
      if (ref.origin !== window.location.origin) return null;
      if (ref.pathname === window.location.pathname && ref.search === window.location.search) return null;
      return ref.href;
    } catch (error) { return null; }
  }

  function upgradeFooterBackLinks(root) {
    if (!isTablet()) return;
    var context = root && root.querySelectorAll ? root : document;
    context.querySelectorAll('[data-kfa-footer-history-back]').forEach(function (link) {
      if (link.dataset.kfaIpadBackReady === '1') return;
      link.removeAttribute('data-kfa-footer-history-back');
      link.dataset.kfaIpadBackReady = '1';
      link.addEventListener('click', function (event) {
        if (!isTablet()) return;
        event.preventDefault();
        var target = sameOriginReferrer() || link.href;
        if (target) window.location.assign(target);
      });
    });
  }

  function initialise() {
    syncTabletClass();
    clearBackForwardTransitionState();
    upgradeFooterBackLinks(document);

    var observer = new MutationObserver(function (mutations) {
      if (!isTablet()) return;
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('[data-kfa-footer-history-back]')) {
            upgradeFooterBackLinks(node.parentElement || document);
          } else if (node.querySelectorAll) {
            upgradeFooterBackLinks(node);
          }
        });
      });
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }
})();
